import Modal from '@mui/material/Modal'; // Importa el componente Modal de Material UI para crear modales
import Box from '@mui/material/Box'; // Importa Box de Material UI para crear contenedores flexibles
import { Typography } from '@mui/material'; // Importa Typography para manejar el estilo del texto
import Button from "@mui/material/Button"; // Importa Button para los botones
import { useState } from 'react'; // Importa useState para manejar el estado del componente
import { Grid } from '@mui/system'; // Importa Grid para crear una cuadrícula
import CloseIcon from '@mui/icons-material/Close'; // Importa el icono de cerrar

import logo1 from "../assets/logoUNAM.png";
import logo2 from "../assets/logoIMATE.png";
import logo3 from "../assets/logoLabVS.png";


// Estilo para el componente de bienvenida (modal)
const style = {
  position: 'absolute',
  top: '50%', // Centra el modal verticalmente
  left: '50%', // Centra el modal horizontalmente
  transform: 'translate(-50%, -50%)', // Ajusta la posición para que esté completamente centrado
  width: 800, // Establece el ancho del modal
  bgcolor: 'white', // Fondo blanco
  border: '2px solid #000', // Borde negro
  boxShadow: 24, // Sombra alrededor del modal
  p: 4, // Padding (espaciado interno)
};

export default function Welcome() {
  const [open, setOpen] = useState(true);   // Estado para controlar si el modal está abierto o cerrado
  const handleClose = () => setOpen(false); // Función para cerrar el modal (mensaje de bienvenida)
  
  return (
    <Modal // Modal para mostrar el mensaje de bienvenida
      open={open} // Determina si el modal está visible
      onClose={handleClose} // Al cerrar el modal se ejecuta la función handleClose
    >
      <Box
        sx={style} // Estilo del modal
      >
        <Button onClick={handleClose} sx={{position:"absolute", top: "1px", right: "5px"}}> {/* Botón para cerrar el modal */}
          <CloseIcon sx={{color:"black"}}/> {/* Icono de cerrar */}
        </Button>
        <Box paddingRight="5%" paddingLeft="5%"> {/* Contenedor principal con espaciado a los lados */}
          <Box sx={{bgcolor: "white", borderRadius: "5px"}}> {/* Contenedor secundario con fondo blanco y bordes redondeados */}
            <Grid container spacing={4} paddingLeft="25%" > {/* Crea un Grid con espaciado entre los elementos */}
              <Grid item xs={2}>
                <img src={logo1} width={100}/> {/* Logo de la UNAM */}
              </Grid>
              <Grid item xs={2} marginTop="20px">
                <img src={logo2} width={100}/> {/* Logo del IMATE */}
              </Grid>
              <Grid item xs={2} paddingTop="10px">
                <img src={logo3} width={100}/> {/* Logo del laboratorio LabVS */}
              </Grid>
              
            </Grid>
          </Box>
          <Box sx={{marginTop: "2px"}}>
             <Typography variant='h5' textAlign="center" color="black">
              Te damos la bienvenida al sitio del 
              <br />
              <strong> Laboratorio de visualización y sonorización </strong> 
              <br />
              de matemáticas, un proyecto del
              <br />
               Instituto de Matemáticas de la UNAM. 
              {/* to the website of the Laboratory for visualization and sonification of mathematics, a project from the Institute of Mathematics, UNAM. */}
            </Typography>
          </Box>
        </Box>
      </Box>
    </Modal>
  )
}

